import wButton from './w-button.vue';

import { installer } from '#util';

export const Button = { install: installer([wButton]) };
export { wButton };
